var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"intro"},_vm._l((_vm.introToDisplay),function(introItem,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(introItem.content)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }